function initialState() {
    return {
        is_show_header: true,
        is_show_footer: true,
        hide_on_routes :['cart', 'order-summary', 'cart-user-info', 'dealer-services'],
        is_show_in_campaign: true,
        hide_on_campaign_routes : ['campaign_en', 'campaign_fi']
    };
}

const getters = {
    is_show_header: state => state.is_show_header,
    is_show_footer: state => state.is_show_footer,
    is_show_in_campaign : state => state.is_show_in_campaign
}

const actions = {
    setHeaderControl({commit}, route_name) {
        commit("setHeaderControl", route_name)
    },
    setFooterControl({commit}, route_name) {
        commit("setFooterControl", route_name)
    },
    setCampaignControl({commit}, route_name) {
        commit("setCampaignControl", route_name)
    }
}

const mutations = {
    setHeaderControl(state, route_name) {
        state.is_show_header = state.hide_on_routes.indexOf(route_name) === -1
    },
    setFooterControl(state, route_name) {
        state.is_show_footer = state.hide_on_routes.indexOf(route_name) === -1
    },
    setCampaignControl(state, route_name) {
        state.is_show_in_campaign = state.hide_on_campaign_routes.indexOf(route_name) === -1
    }
}

export default {
    namespaced : true,
    state : initialState,
    getters,
    actions,
    mutations
}